



























































































































































































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Queens_Lab4_ReportSheet3',
  components: {
    ChemicalLatex,
    ChemicalNotationInput,
    FileUploadUiComponent,
    TableInput,
    STextarea,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        unknownCode: null,

        unknownInitialObs: null,
        unknownInitialInf: null,

        unknownAndCrObs: null,
        unknownAndCrInf: null,

        unknownAndCoObs: null,
        unknownAndCoInf: null,

        unknownAndCuObs: null,
        unknownAndCuInf: null,

        unknownAndFeIIIObs: null,
        unknownAndFeIIIInf: null,

        unknownAndFeIIObs: null,
        unknownAndFeIIInf: null,

        unknownAndNiObs: null,
        unknownAndNiInf: null,

        anionIdentity: null,

        explanation: null,
      },
      anionOptions: [
        {text: '$\\ce{I^-}$', value: 'iodide'},
        {text: '$\\ce{OH^-/NH3}$', value: 'hydroxideAmmonia'},
        {text: '$\\ce{OH^-/CO3^2-}$', value: 'hydroxideCarbonate'},
        {text: '$\\ce{CrO4^2-}$', value: 'chromate'},
      ],
    };
  },
};
